import style from './style.css';

const AdvantageCard = ({ icon, heading, subHeading }) => {
  return (
    <div className={style.container}>
      <img src={icon} className={style.icon} />
      <div className={style.text}>
        <div className={style.heading}>{heading} </div>
        <div className={style.subHeading}>{subHeading} </div>
      </div>
    </div>
  );
};

export default AdvantageCard;



// WEBPACK FOOTER //
// ./routes/campaign-activation/componentsVC/whyCardlessEmi/advantageCard/index.js